import React from 'react';

const passwordField = (props) => {
	let fieldDetail = JSON.parse(props.fieldDetails);
	return (
		<input onKeyDown={props.keyDownHandler} onChange={props.changed} autoComplete="new-password" type={fieldDetail.passwordShow ? "password" : "text"} name={props.fieldKey} className={fieldDetail.classname} placeholder={fieldDetail.placeHolder} value={fieldDetail.value} disabled={fieldDetail.disabled}/>
	);
}

export default passwordField;